<template>
    <products-carousel-section
        class="menu-carousel-section-module"
        :title="attributes.menuCarousel_title"
        :slides="formattedSlides"
        :button-text="attributes.menuCarousel_button_text"
        :button-link="buttonLink"
        :show-navigation-buttons="attributes.menuCarousel_show_navigation_buttons"
    />
</template>

<script>
    import ProductsCarouselSection from '../../../organisms/ProductsCarouselSection/ProductsCarouselSection';
    import { formatMenuSlides } from '../../../../utils/formatters/format-carousel-slide-data';

    export default {
        name: 'menu-carousel-section-module',

        components: { ProductsCarouselSection },

        props: {
            attributes: {
                type: Object,
                required: true,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Safely return the button link.
             *
             * @returns {string}
             */
            buttonLink() {
                return this.attributes.menuCarousel_button_link
                    ?.uri;
            },

            /**
             * Format api data for the OurMenuCarousel component.
             *
             * @returns {Array}
             */
            formattedSlides() {
                return formatMenuSlides(this, this.attributes.products);
            },
        },
    };
</script>

